import Bout from "../../bout/Bout.js";
import Styler from "../featurer/Styler.js";

export default class Saver {
	static save(maze, tileMap, featurer) {
		let save = {};
		save.initer = Saver.getIniter(maze.initer);
		save.maze = Saver.getMaze(maze.mazeDesign.maze);
		save.rooms = Saver.getRooms(maze.mazeDesign.rooms);
		save.startCell = maze.startCell.id;
		save.endCell = maze.endCell.id;
		save.roomsExits = Saver.getRoomsExits(maze.roomsExits);
		save.secretRooms = Saver.getSecretRooms(maze)
		save.columns = Saver.getColumns(tileMap);
		save.featurer = { dungeon: featurer.dungeon, gameLevel: featurer.gameLevel, levelCol: featurer.levelCol, levelRow: featurer.levelRow };
		save.state = Bout.that.getSaveState();
		return save;
	}

	static getMaze(maze) {
		let ret = new Array();
		for (let row = 0; row < maze.length; row++) {
			ret.push(new Array())
			for (let col = 0; col < maze[0].length; col++) {
				let cell = Saver.getFlat(maze[row][col]);
				ret[ret.length - 1].push(cell);
			}
		}
		return ret;
	}

	static getColumns(tileMap) {
		let ret = new Array();
		let mobs = tileMap.mobs;
		for (var x = 0; x < mobs.length; x++) {
			let mob = mobs[x]
			if (mob.clas === "column") {
				ret.push({ cell: mob.cell.id, column: mob.cell.column });
			}
		}
		return ret;
	}


	static getRooms(rooms) {
		let ret = new Array();
		for (let x = 0; x < rooms.length; x++) {
			let room = Saver.getFlat(rooms[x]);
			//console.log(rooms[x])
			//console.log(room.cells.slice())
			let cells = new Array();
			for (let row = 0; row < room.cells.length; row++) {
				cells.push(new Array())
				for (let col = 0; col < room.cells[0].length; col++) {
					cells[cells.length - 1].push(room.cells[row][col].id);
				}
			}
			room.cells = cells;
			ret.push(room);
		}
		return ret;
	}

	static getSecretRooms(maze) {
		let ret = new Array();
		let a = maze.rooms;
		for (let x = 0; x < a.length; x++) {
			let room = a[x];
			if (room.isSecret()) {
				ret.push(room.id);
			}
		}
		return ret;
	}


	static getRoomsExits(exits) {
		let ret = new Array();
		for (let x = 0; x < exits.length; x++) {
			let o = new Object();
			o.id = exits[x].id;
			o.roomExits = new Array();
			for (let y = 0; y < exits[x].roomExits.length; y++) {
				o.roomExits.push(exits[x].roomExits[y].id);
			}
			ret.push(o);
		}
		return ret

	}


	static getFlat(o) {
		let ret = new Object();
		for (var prop in o) {
			ret[prop] = o[prop];
		}
		return ret;
	}


	static getIniter(initer) {
		//console.log(initer)
		let ret = new Object();
		ret.rows = initer.rows;
		ret.cols = initer.cols;
		ret.fov = initer.fov;
		ret.secretRooms = initer.secretRooms;
		ret.rooms = new Array();
		let a = initer.rooms;
		for (let x = 0; x < a.length; x++) {
			let o = Saver.getFlat(a[x]);
			ret.rooms.push(o)
		}
		ret.styler = new Object();
		ret.styler.kit = Saver.getFlat(initer.styler.kit);
		ret.styler.style = initer.styler.style;
		return ret;
	}


	static setStyler(initer) {
		let styler = new Styler();
		let o = initer.styler;
		for (var prop in o) {
			styler[prop] = o[prop];
		}
		return styler;
	}

	static setCellDesing(o, cellDesign) {
		for (var prop in o) {
			cellDesign[prop] = o[prop];
		}
	}

	static setRoomDesign(o, roomDesign, mazeDesign) {
		for (var prop in o) {
			roomDesign[prop] = o[prop];
		}
		//roomDesign.cells = new Array();
		//console.log(o.cells.length)
		//console.log(o.cells[0].length)
		let cells = new Array();

		for (let row = 0; row < o.cells.length; row++) {
			cells.push(new Array())
			for (let col = 0; col < o.cells[0].length; col++) {
				let id = o.cells[row][col];
				//console.log(id)
				let cellDesign = Saver.getFromMatrix(id, mazeDesign);
				//roomDesign.cells[row, col] = cellDesign;
				cells[cells.length - 1].push(cellDesign);
			}
		}
		roomDesign.cells = cells;

	}

	static getFromMatrix(id, matrix) {
		for (let row = 0; row < matrix.length; row++) {
			for (let col = 0; col < matrix[0].length; col++) {
				let cell = matrix[row][col];
				if (cell.id === id) {
					return cell;
				}
			}
		}
		return null;
	}

}

